import PrivateRoute from '../../core/PrivateRoute';
import GroupIcon from '@material-ui/icons/Group';
import PersonIcon from '@material-ui/icons/Person';
import SyncIcon from '@material-ui/icons/Sync';
import CodeIcon from '@material-ui/icons/Code';
import ExploreIcon from '@material-ui/icons/Explore';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import PageLayout from '../../core/PageLayout';
import GS from '../../grafsync/grafsync';
import GroupsManager from '../groups/GroupsManager';
import UsersManager from '../users/UsersManager';
import SettingsManager from '../settings/SettingsManager';
import IntegrationManager from '../integration/IntegrationManager';
import SparqlManager from '../sparql/SparqlManager';
import SnapshotManager from '../snapshot/SnapshotManager';
import SettingsIcon from '../../core/icons/Settings';
import ApiManager from '../api/ApiManager';
import { ENTITLEMENTS as APPENTITLEMENTS } from '../../core/utils/constants';

const options = [
  {
    name: "Settings",
    url: 'settings',
    entitlement: APPENTITLEMENTS.MANAGE_SETTINGS,
    icon: <SettingsIcon />
  }, {
    name: "Users",
    url: 'users',
    entitlement: APPENTITLEMENTS.EDIT_USER,
    icon: <PersonIcon />
  },
  {
    name: "Groups",
    url: 'groups',
    entitlement: [APPENTITLEMENTS.EDIT_GROUP, APPENTITLEMENTS.CREATE_GROUP],
    icon: <GroupIcon />
  },
  {
    name: "Snapshots",
    url: 'snapshots',
    entitlement: APPENTITLEMENTS.MANAGE_SNAPSHOTS,
    icon: <SaveAltIcon />
  },
  {
    name: "SPARQL",
    url: 'sparql',
    entitlement: APPENTITLEMENTS.CAN_QUERY,
    icon: <ExploreIcon />
  },
  {
    name: "Integrations",
    url: 'integrations',
    entitlement: APPENTITLEMENTS.MANAGE_INTEGRATION,
    icon: <SyncIcon />
  },
  {
    name: "API",
    url: 'api',
    entitlement: APPENTITLEMENTS.MANAGE_INTEGRATION,
    icon: <CodeIcon />
  }
];

const baseURL = "/dashboard";

class DashboardManager extends Component {

  render() {

    const pageCrumb = <Switch>
      <Route path={baseURL + "/settings"} render={() => <span>Settings</span>} />
      <Route path={baseURL + "/integrations"} render={() => <span>Integrations</span>} />
      <Route path={baseURL + "/sparql"} render={() => <span>SPARQL</span>} />
      <Route path={baseURL + "/snapshots"} render={() => <span>Snapshots</span>} />
      <Route path={baseURL + "/api"} render={() => <span>API</span>} />
      <Route path={baseURL + "/users"} render={() => <span>Users</span>} />
      <Route path={baseURL + "/groups"} render={() => <span>Groups</span>} />
    </Switch>;

    return (
      <PageLayout
        title="Dashboard"
        baseURL="/dashboard"
        options={options}
        graph={GS.getActiveSubscription()}
        layoutTitle={function () { return (pageCrumb); }}
        breadcrumb={{
          baseURL,
          title: "Dashboard",
          static: pageCrumb,
          path: ["settings", "sparql", "snapshots", "integrations", "users", "groups"],
          url: {
            settings: "settings",
            sparql: "sparql",
            snapshots: "snapshots",
            integration: "integrations",
            users: "users",
            groups: "groups"
          }
        }}>
        <Switch>
          <PrivateRoute
            entitlement={
              [
                APPENTITLEMENTS.MANAGE_SETTINGS
              ]
            }
            exact
            path={baseURL + "/settings"}
            component={SettingsManager} />
          <PrivateRoute
            entitlement={
              [
                APPENTITLEMENTS.MANAGE_INTEGRATION
              ]
            }
            exact
            path={baseURL + "/integrations"}
            component={IntegrationManager} />
          <PrivateRoute
            entitlement={
              [
                APPENTITLEMENTS.CAN_QUERY
              ]
            }
            exact
            path={baseURL + "/sparql"}
            component={SparqlManager} />
          <PrivateRoute
            entitlement={
              [
                APPENTITLEMENTS.MANAGE_SNAPSHOTS
              ]
            }
            exact
            path={baseURL + "/snapshots"}
            component={SnapshotManager} />
          <PrivateRoute
            entitlement={
              [
                APPENTITLEMENTS.MANAGE_INTEGRATION
              ]
            }
            exact
            path={baseURL + "/api"}
            component={ApiManager} />
          <PrivateRoute
            entitlement={
              [
                APPENTITLEMENTS.EDIT_USER
              ]
            }
            exact
            path={baseURL + "/users"}
            component={UsersManager} />
          <PrivateRoute
            entitlement={
              [
                APPENTITLEMENTS.EDIT_GROUP,
                APPENTITLEMENTS.CREATE_GROUP
              ]
            }
            exact
            path={baseURL + "/groups"}
            component={GroupsManager} />
          <Route render={() => <Redirect to={{ pathname: '/dashboard' }} />} />
        </Switch>
      </PageLayout>
    );
  }
}

export default DashboardManager;